module.exports = __webpack_public_path__ + "static/media/1022695.70a4e380.jpg";